(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */
    var initializeBlock = function( $block ) {
        var mapAdresses = [];
        // si on utilise pas les adresse de la page options
        if($($block).hasClass('is-not-general')){
            mapAdresses[0] = $block.find('.map').data('address');
        }else{
            mapAdresses = mapData.adresses;
        }

        var mainPoint = mapAdresses[0]; 
		var map;
		var MY_MAPTYPE_ID = 'custom_style';
        var lat = mainPoint.lat;
        var lng = mainPoint.lng;
        
        var markerPos = new google.maps.LatLng(lat, lng);
                
        var featureOpts = [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": '#1a1a1a'
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": '#ededed'
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": '#c5c5c5'
                    },
                    {
                        "visibility": "on"
                    },
                ]
            }
        ];    
                
        var mapOptions = {
            zoom: 13,
            scrollwheel : false,
            zoomControl: true,
            disableDefaultUI: true,
            center: markerPos,
            labelContent: mapData.siteName,
            mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
            },
            mapTypeId: MY_MAPTYPE_ID
        };// mappOptions
                
        map = new google.maps.Map($block.find('.map')[0], mapOptions);
        
        var styledMapOptions = {
            name: 'Custom Style'
        };//StyledMapOptions
                
        var customMapType = new google.maps.StyledMapType(featureOpts, styledMapOptions);
        
        map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

        // const mainMarker = {
        //     path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
        //     fillColor: mapData.themeColors[0].color,
        //     fillOpacity: 1,
        //     strokeWeight: 0,
        //     rotation: 0,
        //     scale: 0.1, // grossir ici si vous voulez 
        //     anchor: new google.maps.Point(150, 500), // ne pas jouer avec ses données
        // };

        // si pour avoir un markeur en image 
        const mainMarker = {
            //anchor: new google.maps.Point(64,52),
         url:siteData.themeUri + '/images/marker.png',
         anchor: new google.maps.Point(50, 90), 
        };

        var bounds = new google.maps.LatLngBounds();

        $.each(mapAdresses,function(index, val){

            let markerOpts = {
                position: new google.maps.LatLng(val.lat, val.lng),
                map: map,
                icon: mainMarker,
            };

            var markerMap = new google.maps.Marker(markerOpts);

            var htmlPopup = '';

            htmlPopup += '<div class="content-infopup-wrapper">';
            htmlPopup += mapData.htmlLogo;
            htmlPopup += '<a data-direction="'+val.address+'" href="https://www.google.ca/maps/dir//'+encodeURIComponent(val.address)+'" target="_blank" rel="nooponer">'+val.address+'</a>';
            htmlPopup += '<a data-direction="'+val.address+'" href="https://www.google.ca/maps/dir//'+encodeURIComponent(val.address)+'" target="_blank" rel="nooponer">'+mapData.itineraire+'</a>';
            htmlPopup += '</div>';

            var infowindow = new google.maps.InfoWindow({
                content: htmlPopup
            });

            markerMap.addListener('click', function() {
                infowindow.open(map, markerMap);
            });

            bounds.extend(new google.maps.LatLng(val.lat, val.lng));

        });

        if(mapAdresses.length > 1){
            map.fitBounds(bounds);
        }
    }

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.google-map').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=googlemap', initializeBlock );

        window.acf.addAction('google_map_init', function( map, marker, field ){ // Signale lorsque le champ google map est prêt à être modifié.
            field.mapReady = true;
            window.acf.doAction('field_map_ready', field, map);
        });

        window.acf.addAction('new_field/name=utiliser_ladresse_generale', function(field){
            field.on('change', 'input', function( e ){ // Quand on change le true/false.
                let ACFmap = window.acf.getField(window.acf.findFields({name: 'map', sibling: field.$el})); // Le champ map associé au true/false.
                
                if(ACFmap.mapReady){ // Si le champ de la map est prêt à être manipulé.
                    if(field.$input().prop('checked')){
                        ACFmap.$el.find('input.search').hide(); // on cache la barre de recherche.
                        ACFmap.searchPositionCopy = ACFmap.searchPosition; // Garde en copy la function pour positionner le marker au clic.
                        ACFmap.searchPosition = function(){return false;}; // On désactive la fonction de click pour positionner le marker.
                        ACFmap.map.marker.setDraggable(false); // désactive le drag and drop du marker.

                        // On va chercher l'adresse générale et on change la valeur de la carte.
                        jQuery.post(window.wp.ajax.settings.url, {action: 'theme_client_get_option_address'}, function(res){
                            JSON.stringify(res);
            
                            ACFmap.val(res);
                        }, 'json');

                    }else{ // On réactive les options de positionnement du marker.
                        ACFmap.$el.find('input.search').show();
                        ACFmap.searchPosition = ACFmap.searchPositionCopy;
                        ACFmap.map.marker.setDraggable(true);
                    }

                }else{ // Si la map est pas prête, on attent l'action.
                    window.acf.addAction('field_map_ready', function(mapField, map){
                        if(mapField.cid == ACFmap.cid){
                            field.$input().trigger('change');
                        }
                    });
                }
            });

            field.$input().trigger('change');
        });
    }

})(jQuery);